"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageBanner = exports.ImageBannerDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var image_overlay_1 = require("./image-overlay");
var responsive_image_1 = require("./responsive-image");
exports.ImageBannerDefaultProps = {
  fill: true,
  aspectRatio: {
    base: 21 / 9,
    tablet: 21 / 9
  }
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n\n    ", "\n  "], ["\n    position: relative;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.base && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.base * 100);
  }),
  landscape: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.landscape && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.landscape * 100);
  }),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.tablet && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.tablet * 100);
  }),
  desktop: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.desktop && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.desktop * 100);
  }),
  desktopLarge: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.desktopLarge && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.desktopLarge * 100);
  })
});
var ImageOverlayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n  "], ["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(responsive_image_1.ResponsiveImage)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ImageOverlay: (0, styled_components_1.default)(image_overlay_1.ImageOverlay)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ImageOverlayStyles)
};
var ImageBanner = function (props) {
  var className = props.className,
    image = props.image,
    overlay = props.overlay,
    aspectRatio = props.aspectRatio,
    fill = props.fill;
  return React.createElement(My.Container, {
    image: image,
    fill: fill,
    aspectRatio: aspectRatio,
    className: className
  }, overlay && React.createElement(My.ImageOverlay, null, overlay));
};
exports.ImageBanner = ImageBanner;
exports.ImageBanner.defaultProps = exports.ImageBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;